/* eslint-disable no-redeclare */
import { USAStateAcronym } from '@hc-frontend/core-types';
import { IHttpRequest } from '@hc-frontend/core-utils-net';
import { IHttpCall } from '@hc-frontend/core-utils-net';
import { z } from 'zod';

export const GetFplRequestDto = z.object({
  HouseIncome: z.number().optional(),
  HouseHoldSize: z.number(),
  State: USAStateAcronym,
});
export type GetFplRequestDto = z.infer<typeof GetFplRequestDto>;

export const GetFplResponseDto = z.object({
  isSuccess: z.boolean(),
  message: z.string(),
  data: z.number(),
});

export type GetFplResponseDto = z.infer<typeof GetFplResponseDto>;

export type GetFplOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};
